import React from 'react';
import Style from '../Assets/Styles/Pages/Blog.module.css';

const Blog = () => {
    return (
        <>
            <div className={`${Style.mainHero} container-fluid`}>
                <h1>Blog</h1>
            </div>
        </>
    )
}
export default Blog;